import React from "react";
import Table from "../../Common/Table";
import Pagination from "../../Common/Pagination";
import useAddDues from "./useAddDues";
import icons from "../../../assets/images/constantIcons";

const Dues = () => {
  const {
    columns,
    currentRows = [], // Ensure default value to avoid `undefined`
    totalRows,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    loading,
    searchQuery,
    setSearchQuery,
  } = useAddDues();

  return (
    <div className="flex flex-col px-4 py-4">
      <h1 className="main_heading text-2xl xl:text-[30px] mb-3">Dues</h1>
      {/* Search Bar */}
      <div className="flex sm:justify-end ">
        <div className="flex items-center border border-gray-300 bg-white px-3 py-2 rounded-lg w-full max-w-[250px]">
          <icons.GoSearch className="text-gray-500 mr-2" />
          <input
            name="search"
            type="text"
            placeholder="Search id, player, location"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full outline-none bg-transparent text-gray-700 placeholder-gray-400 placeholder:text-xs"
          />
        </div>
      </div>
      {loading ? (
        <div className="flex justify-center items-center my-4">
          <p className="text-green700 font-medium">Loading data...</p>
        </div>
      ) : (
        <div className="my-2 mb-6 overflow-auto horizontalscroll">
          <Table columns={columns} data={currentRows} />
        </div>
      )}

      {/* Pagination */}
      <Pagination
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </div>
  );
};

export default Dues;
